import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--spacing-small);
	align-items: center;

	.grey {
		color: var(--neutrals-700);
	}
	.clickable {
		cursor: pointer;
	}
`;
